export default {
  FETCH_PROJECT_PARTICIPANTS_DETAIL_REQUEST: 'FETCH_PROJECT_PARTICIPANTS_DETAIL_REQUEST',
  FETCH_PROJECT_PARTICIPANTS_DETAIL_SUCCESS: 'FETCH_PROJECT_PARTICIPANTS_DETAIL_SUCCESS',
  FETCH_PROJECT_PARTICIPANTS_DETAIL_FAILURE: 'FETCH_PROJECT_PARTICIPANTS_DETAIL_FAILURE',
  FETCH_PROJECT_SUBSCRIBERS_DETAIL_REQUEST: 'FETCH_PROJECT_SUBSCRIBERS_DETAIL_REQUEST',
  FETCH_PROJECT_SUBSCRIBERS_DETAIL_SUCCESS: 'FETCH_PROJECT_SUBSCRIBERS_DETAIL_SUCCESS',
  FETCH_PROJECT_SUBSCRIBERS_DETAIL_FAILURE: 'FETCH_PROJECT_SUBSCRIBERS_DETAIL_FAILURE'
}
